import { METHOD } from './method'

export const API_BRAND = {
    LIST: {
        api: '/v1/dashboard-admin/brand/list',
        method: METHOD.POST,
    },
    UPDATE_STATUS: {
        api: '/v1/dashboard-admin/brand/status',
        method: METHOD.PUT,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/brand/export',
        method: METHOD.POST,
    },
    DETAIL: {
        api: '/v1/dashboard-admin/brand',
        method: METHOD.GET,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/brand/product',
        method: METHOD.GET,
    },
    URL_BRAND_IMAGES: {
        api: '/v1/dashboard-admin/brand/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/brand',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/brand',
        method: METHOD.PUT,
    },
}
